import { PromoRewardsConfig } from './PromoRewards.types';

export const PROMO_REWARDS_CONFIG: PromoRewardsConfig = {
  FreeSpins: {
    icon: 'freeSpins',
    text: 'freeSpins',
  },
  Coins: {
    icon: 'bettyCoin',
    text: 'bettyCoins',
  },
  InstantWheel: {
    icon: 'rewardWheel',
    text: 'wheelSpins',
  },
  Cash: {
    icon: 'bettyDollar',
  },
};
